import React from 'react';
import ReactMarkdown from 'react-markdown';

import news1 from './news/news1.md.js';
import news2 from './news/news2.md.js';
import news3 from './news/news3.md.js';
import news4 from './news/news4.md.js';
import article01 from './news/article01.md.js';
import article02 from './news/article02.md.js';
import article03 from './news/article03.md.js';
import article04 from './news/article04.md.js';

// import navigation 
import { useNavigate } from 'react-router-dom';


// Helper to render a news article from markdown
function NewsArticle({ markdownFile }) {
  const navigate = useNavigate();

  // use navigation 
  return (
    <div className="fogged-card" style={{
      maxWidth: '70vw',
      width: '90%',
      margin: '2rem auto',
      background: 'rgba(0,0,0,0.4)',
      color: 'white',
      borderRadius: 12,
      boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      padding: '2.5rem 2rem'
    }}>

      {/* Button to navigate back to /news  */}
      <button onClick={() => navigate('/')} style={{
        marginBottom: 16,
        padding: '8px 16px',      
        background: 'lightgrey',
        border: 'none',
        borderRadius: 4,
        cursor: 'pointer',
        color: 'black',
        fontWeight: 'bold'
      }}>
        &larr; Back to Home
      </button>

      <div style={{marginBottom: 32, borderBottom: '1px solid #eee', paddingBottom: 16}}>
        <ReactMarkdown>{markdownFile}</ReactMarkdown>
      </div>
    </div>
  );
}

export function NewsArticle1() {
  return <NewsArticle markdownFile={news1} />;
}

export function NewsArticle2() {
  return <NewsArticle markdownFile={news2} />;
}

export function NewsArticle3() {
  return <NewsArticle markdownFile={news3} />;
}
export function NewsArticle4() {
  return <NewsArticle markdownFile={news4} />;
}

export function Article01() {
  return <NewsArticle markdownFile={article01} />;
}

export function Article02() {
  return <NewsArticle markdownFile={article02} />;
}

export function Article03() {
  return <NewsArticle markdownFile={article03} />;
}
export function Article04() {
  return <NewsArticle markdownFile={article04} />;
}
